import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=7567c93c&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=ts&"
export * from "./addQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=7567c93c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567c93c",
  null
  
)

export default component.exports